import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ReporteRibisoftEntity, ReporteRibisoftDataEntity } from 'src/app/services/servicio-facturacion.service';
import { ExcelService } from 'src/app/services/utils/excel.service';
import { FechaService } from 'src/app/services/utils/fecha.service';
import { ServicioSedesService, SedeEntity } from 'src/app/services/servicio-sedes.service';
import { Subscription } from 'rxjs';
import { SelectItem } from 'primeng/api';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-header-reporte-ribisoft',
  templateUrl: './header-reporte-ribisoft.component.html',
  styleUrls: ['./header-reporte-ribisoft.component.css']
})
export class HeaderReporteRibisoftComponent implements OnInit {

  identificador: number;
  fechaInicial: string;
  fechaFinal: string;
  sede: number;

  downloading: boolean;

  listaSedes: SelectItem[] = [];
  listasedesSelected: SelectItem[] = [];

  sedeSubscription: Subscription;

  @Input() objectReporteRibisoft: ReporteRibisoftEntity;
  @Input() dataReporteRibisoft: ReporteRibisoftDataEntity[];
  @Output() filtrosSeleccionados: EventEmitter<any>;
  @Output() errorGenerado: EventEmitter<any>;

  constructor(private servicioExcel: ExcelService,
              private servicioFecha: FechaService,
              private servicioSede: ServicioSedesService) {
    this.filtrosSeleccionados = new EventEmitter();
    this.errorGenerado = new EventEmitter();
  }

  async ngOnInit() {
    this.identificador = 1;
    this.fechaInicial = this.servicioFecha.getInputValue(new Date().getTime());
    this.fechaFinal = this.servicioFecha.getInputValue(new Date().getTime());
    this.getSedes();
  }

  async getSedes() {
    try {
      this.listaSedes = [];
      const response = await this.servicioSede.getSedesBySede(this.objectReporteRibisoft.codigo, this.objectReporteRibisoft.sede);
      this.sedeSubscription = response.subscribe((data: SedeEntity[]) => {
        if (data && data.length > 0) {
          data.forEach((s: SedeEntity) => {
            this.listaSedes.push({ label : s.descripcion, value : s.unco});
          });
          this.sede = this.objectReporteRibisoft.sede;
          this.onGenerar();
        }
      }, (err: HttpErrorResponse) => {
        console.error('HeaderReporteRibisoft.getSedes()', err);
        this.errorGenerado.emit('No fue posible obtener las sedes, verifique su conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch HeaderReporteRibisoft.getSedes()', e);
      this.errorGenerado.emit('No fue posible obtener las sedes, verifique su conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  onGenerar() {
    const inicio = this.servicioFecha.getFecha(this.fechaInicial);
    const fin = this.servicioFecha.getFecha(this.fechaFinal);

    if ( this.listasedesSelected.length === 0) {
      this.errorGenerado.emit('Debe seleccionar al menos una <strong>Sede</strong>.');
    } else if (this.identificador < 3 && inicio === null) {
      this.errorGenerado.emit('Debe seleccionar una <strong>Fecha</strong> valida.');
    } else if (this.identificador === 3 && inicio === null) {
      this.errorGenerado.emit('Debe seleccionar una <strong>Fecha Inicial</strong> valida.');
    } else if (this.identificador === 3 && fin === null) {
      this.errorGenerado.emit('Debe selecciona una <strong>Fecha Final</strong> valida.');
    } else if (this.identificador === 3 && this.servicioFecha.compare(inicio, fin) === 1) {
      this.errorGenerado.emit('La <strong>Fecha Inicial</strong> debe ser menor o igual a la <strong>Fecha Final</strong>.');
    } else {
      
      const obj: ReporteRibisoftEntity = {
          inicio : inicio.getTime(),
          fin : fin.getTime(),
          codigo : this.objectReporteRibisoft.codigo,
          sede: this.objectReporteRibisoft.sede,
          sedes : String(this.listasedesSelected),
          identificador : this.identificador
      };
      this.filtrosSeleccionados.emit(obj);
    }

  }

  onImprimir() {
    let printContents: any, popupWin: any;

    printContents = document.getElementById('reporte-ribisoft').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO"
          crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents }</body>
      </html>`
    );

    popupWin.document.close();
  }

  onDescargarExcel() {
    this.downloading = true;
    if (this.dataReporteRibisoft && this.dataReporteRibisoft.length > 0) {
      const finalData: any[] = [];
      this.dataReporteRibisoft.forEach((data: ReporteRibisoftDataEntity) => {
        const obj: any = {
          'numero' : data.numero,
          'tipocliente' : data.tipoCliente,
          'tipodocumento': data.tipoDocumento,
          'nitcliente' : data.nitCliente,
          'razonsocialcliente' : data.razonSocialCliente,
          'nombre1' : data.nombre1,
          'nombre2' : data.nombre2,
          'apellido1' : data.apellido1,
          'apellido2' : data.apellido2,
          'emailcliente' : data.emailCliente,
          'telefonocliente' : data.telefonoCliente,
          'direccioncliente' : data.direccionCliente,
          'fechacreacion' : this.servicioFecha.getDateTimeValue(new Date(data.fechaCreacion)),
          'observaciones' : data.observaciones,
          'fechavencimiento' : this.servicioFecha.getDateTimeValue(new Date(data.fechaVencimiento)),
          'porcretefuente' : data.porcentajeFuente,
          'retefuente' : data.retefuente,
          'subtotal' : data.subtotal,
          'total' : data.total,
          'totalitems' : data.totalItems,
          'valordescuento' : data.valorDescuento,
          'valorimpoconsumo' : data.valorImpoconsumo,
          'valoriva' : data.valorIva,
          'reteiva' : data.reteiva,
          'reteica' : data.reteica,
          'trm' : data.trm,
          'rsnumero': data.resolucion,
          'rsprefijo' : data.prefijo,
          'idreferencia' : data.referencia,
          'descripcion' : data.descripcion,
          'cantidad' : data.cantidad,
          'valor' : data.valor,
          'descuento' : data.descuento,
          'iva' : data.iva,
          'anticipo' : data.anticipo
        };
        finalData.push(obj);
      });
      this.servicioExcel.exportAsExcelFile(finalData, 'reporteFacturacionRibisoft', 'Reporte Facturación Ribisoft');
      this.downloading = false;
    } else {
      this.downloading = false;
      alert('No existe información de reporte filtrada para ser descargada en archivo excel.');
    }
  }
}
